import type { KubernetesScriptProperties } from "@octopusdeploy/legacy-action-properties";
import type { AccountResource } from "@octopusdeploy/octopus-server-client";
import * as React from "react";
import { repository } from "~/clientInstance";
import KubernetesNamespaceFormSectionReadOnly from "~/components/Actions/ProcessTemplates/kubernetes/kubernetesNamespaceFormSectionReadOnly";
import { ScriptActionReadOnly } from "~/components/Actions/ProcessTemplates/script/scriptActionReadOnly";
import type { ActionEditProps } from "~/components/Actions/pluginRegistry";
import type { ScriptPackageProperties } from "~/components/Actions/script/ScriptPackageReferenceDialog";
import { BaseComponent } from "~/components/BaseComponent/BaseComponent";
import { SupportedLanguage } from "~/components/ScriptingLanguageSelector/ScriptingLanguageSelector";
interface KubernetesRunScriptActionReadOnlyState {
    accounts: AccountResource[];
}
type KubernetesRunScriptActionReadOnlyProps = ActionEditProps<KubernetesScriptProperties, ScriptPackageProperties>;
export default class KubernetesRunScriptActionReadOnly extends BaseComponent<KubernetesRunScriptActionReadOnlyProps, KubernetesRunScriptActionReadOnlyState> {
    constructor(props: KubernetesRunScriptActionReadOnlyProps) {
        super(props);
    }
    async componentDidMount() {
        await this.props.doBusyTask(async () => {
            this.setState({
                accounts: await repository.Accounts.all(),
            });
        });
    }
    render() {
        return (<div>
                <ScriptActionReadOnly busy={this.props.busy} plugin={this.props.plugin} projectId={this.props.projectId} gitRef={this.props.gitRef} localNames={this.props.localNames} properties={this.props.properties} packages={this.props.packages} setProperties={this.props.setProperties} setPackages={this.props.setPackages} doBusyTask={this.props.doBusyTask} getFieldError={this.props.getFieldError} supportedLanguages={SupportedLanguage.PowerShellAndBash} errors={this.props.errors} expandedByDefault={this.props.expandedByDefault} parameters={this.props.parameters} gitDependencies={this.props.gitDependencies} setGitDependencies={this.props.setGitDependencies} inputDependencies={this.props.inputDependencies} isStepFromProcessTemplate={this.props.isStepFromProcessTemplate}/>
                <KubernetesNamespaceFormSectionReadOnly namespace={this.props.properties["Octopus.Action.KubernetesContainers.Namespace"]} onChange={(ns) => this.props.setProperties({ ["Octopus.Action.KubernetesContainers.Namespace"]: ns })}/>
            </div>);
    }
    static displayName = "KubernetesRunScriptActionReadOnly";
}
